import { createSelector } from "reselect";
import { getActiveLocation } from "./getLocationPermissions";

export const getActiveLocationMembership = createSelector(
    getActiveLocation,
    (location) => location?.membershipPrograms
);
